import { isSetDefault } from '@/utils';
import LastPage from '../last-page';
import SetDefaultPage from '../set-default-page';
import LottiePage from '../lottie-page';

const Page = ({ lottie, titleList, describeText, pageIndex, id }) => {
  if (lottie) {
    return (
      <LottiePage lottie={lottie} titleList={titleList} describeText={describeText} pageIndex={pageIndex} id={id} />
    );
  }
  return isSetDefault ? (
    <SetDefaultPage describeText={describeText} titleList={titleList} id={id} />
  ) : (
    <LastPage describeText={describeText} id={id} />
  );
};

export default Page;
